import {
    trigger,
    transition,
    animate,
    style,
    state,
    AUTO_STYLE,
} from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
    transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('500ms', style({ transform: 'translateY(-50%)' })),
    ]),
    transition(':leave', [
        animate('500ms', style({ transform: 'translateY(-100%)' })),
    ]),
]);

export const fadeInOut = trigger('fadeInOut', [
    transition('void => *', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 0.8 })),
    ]),
    transition('* => void', [animate('500ms', style({ opacity: 0 }))]),
]);

export const collapse = trigger('collapse', [
    state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
    state('true', style({ height: '0', visibility: 'hidden' })),
    transition('false => true', animate(300 + 'ms ease-in')),
    transition('true => false', animate(300 + 'ms ease-out')),
]);

export const modalAnimations = [slideInOut, fadeInOut];
